import '@babel/polyfill'
import Vue from 'vue'
import moment from 'moment'
import App from './App'
import router from './router'
import store from './store'
import api from './api'
import bootstrap from './core/bootstrap'
import constv from './config/constv'
import { version } from '../package.json'
import { STable, UploadImage, QiniuUpload, QiniuUploadTest } from '@/components'
import VueCropper from 'vue-cropper'
import './core/lazy_use'
import './permission'
import './utils/filter'
import './utils/style.less'
// import * as fundebug from 'fundebug-javascript'
// import fundebugVue from 'fundebug-vue'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import zModal from '@/components/Zpace/modal/zModal.vue'
import './utils/directive'
import globalFunction from './utils/globalFunction'
import func from '@/utils/func' // 全局方法
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import './assets/js/tween'

import '@/assets/js/fs'

// if (process.env.NODE_ENV === 'production') {
//   Sentry.init({
//     dsn:
//       'http://6f06a8b6d23c488aa5037ecee6e87385@test-sentry.c82fce5bf83c440a6b9db3edf8d0166b8.cn-shenzhen.alicontainer.com/6',
//     integrations: [new VueIntegration({ Vue, attachProps: true })]
//   })
// }

if (process.env.VUE_APP_ENV === 'prod') {
  Sentry.init({
    dsn: 'http://f8ced428cc7d4d8eab847e90ff3f45c7@sentry-ext.mindcomic.com/5',
    integrations: [new Integrations.Vue({ Vue, attachProps: true, logErrors: true })],
    release: version
  })
}

Vue.use(globalFunction)
Vue.use(func)
Vue.component('zModal', zModal)
Vue.component('swiper', swiper)
Vue.component('swiperSlide', swiperSlide)
// fundebug.apikey = '2305db83f4ab617958fe42b7c68edb741924dee14318d7b817d8efea62f5b883'
// fundebug.init({
//   silentConsole: true
// })
// fundebugVue(fundebug, Vue)
// require('fundebug-revideo')
// import { Modal } from 'ant-design-vue'
Object.defineProperty(Vue.prototype, '$moment', { value: moment })
Vue.config.productionTip = false
Vue.prototype.constv = constv
Vue.use(VueCropper)
Vue.use(api)
Vue.component('upload-image', UploadImage)
Vue.component('qiniu-upload', QiniuUpload)
Vue.component('qiniu-upload-test', QiniuUploadTest)
Vue.component('s-table', STable)

// 监听设置token事件 防止浏览器内多开 共用一个token
window.addEventListener('storage', storageHandle, false)
function storageHandle (e) {
  if (e.key === 'ZPACE_TOKEN' && localStorage.getItem('ZPACE_TOKEN')) {
    window.location.reload()
  }
}
// 重定向域名
// if (window.location.host === 'zpace.cocomix.cn') {
//   window.location.replace('http://www.zpace.com.cn/')
// }
new Vue({
  router,
  store,
  created () {
    bootstrap()
  },
  render: h => h(App),
  mounted () {

  }
}).$mount('#app')
